import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-east-1_yRupyIcxk',
    ClientId: '4uf6fbvprk3nfpjavm68f0dqsv',
};

const userPool = new CognitoUserPool(poolData);

export default userPool;